const PurchaseComponent = () => import('@/views/finance/purchase/PurchaseView')

export default [
    {
        path:'/PurchaseIndex',
        name:'PurchaseComponent',
        component:PurchaseComponent
    }
]